import store from '@/states/index.js'

import Snag from '../SnagComponent.vue'

export default [
    {
        path: '/snags',
        component: Snag,
        name: 'snags',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 3){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]